export default __webpack_public_path__ + "static/media/IMG-20240822-WA0004.5fd55ef0.jpg";